import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboCodInstalacion`, method: 'GET', body: null, token: token})
}